import { EntityList } from '../../../../entity-list/EntityList';
import { Filters } from '../../../../filter/Filters';
import { SortDropdown } from '../../../../list-conductor/SortDropdown/SortDropdown';
import { ListConductorRawFilter } from '../../../../list-conductor/filters';
import { SortDirection } from '../../../../list-conductor/sort';
import { PipelineIntro } from '../../../../pipelines/PipelineList/components/PipelineIntro/PipelineIntro';
import { PipelineListTable } from '../../../../pipelines/PipelineList/components/PipelineListTable/PipelineListTable';
import { PIPELINE_SORT_DROPDOWN_OPTIONS } from '../../../../pipelines/constants/pipeline-sort-options';
import { IntegrationsFactory } from '../../../../pipelines/factories/integrationFactory';
import { getFilterKeyMatchValue, getSortValue, SEARCH_FILTER_KEY } from './Utils';
import { useInMemoryFilteredList } from '../../../../shared/hooks/useInMemoryFilteredList';
import { Destination } from '../../../../shared/interfaces/destination';
import { EntityListEntities } from '../../../../shared/interfaces/entity-list';
import { matchFilters } from '../../../../shared/utils/filters';
import { DestinationAPI } from '../../../api/DestinationAPI';
import { CONNECTED_PIPELINE_FILTERS } from '../../constants/destination-connected-pipelines';

export interface DestinationConnectedPipelineProps {
  destination: Destination;
}

export function DestinationConnectedPipelines({ destination }: DestinationConnectedPipelineProps) {
  const { fetch, reset } = useInMemoryFilteredList(
    async () => {
      const res = await DestinationAPI.getDestinationIntegrations(destination.id);
      return IntegrationsFactory(res.data);
    },
    (item, params) => {
      return matchFilters(params.filters as ListConductorRawFilter[], filterKey =>
        getFilterKeyMatchValue(filterKey, item)
      );
    },
    undefined,
    undefined,
    getSortValue,
    true
  );

  return (
    <EntityList
      entity={EntityListEntities.PIPELINE}
      dataId='connected-pipeline'
      mode='connected'
      dataSource$={fetch}
      listIcon='pipeline'
      entityTitle='Pipelines'
      emptyTitle='No Matching Pipelines Found'
      emptySubTitle='Modify search term to find the desired pipelines'
      searchKey={SEARCH_FILTER_KEY}
      showSearch
      showFilters
      inMemoryList
      onRefresh={() => {
        reset();
      }}
      shimmerColumnsCount={6}
      newListConnectedTitle='No Connected Pipelines'
      NewListComponent={PipelineIntro}
      searchPlaceholder='Search Pipelines'
      genericErrorTitle='Error while fetching Pipelines'
      genericErrorSubTitle='Retry Loading the Pipelines'
      ListComponent={PipelineListTable}
      listComponentProps={{ hideColumns: ['destination'] }}
      SortComponent={SortDropdown}
      defaultListMeta={{ filters: [], sort: { id: SortDirection.DESC } }}
      FiltersComponent={Filters}
      sortComponentProps={{
        sortOptions: PIPELINE_SORT_DROPDOWN_OPTIONS
      }}
      filtersComponentProps={{
        filters: CONNECTED_PIPELINE_FILTERS,
        entity: 'pipeline-list'
      }}
    />
  );
}
